/**
 * @file
 * Global utilities.
 *
 */

/* global jQuery, Drupal */
import queryString from 'query-string';
import mainMenu from './cidrap.main-menu';
import map from 'lodash/map';
import axios from 'axios';

(($, Drupal) => {
  /* eslint-disable no-param-reassign */
  Drupal.behaviors.cidrap_theme = {
    attach: () => {
      once('cvr_theme', 'body').forEach(() => {

        mainMenu($);

        setTimeout(() => {
          // Duplicate search block
          const $searchBlock = $('#search-block-form').clone();
          $('#mm-1').append($searchBlock);
          // Handle Mmenu close
          const mmTitle = document.querySelector('.mm-navbar__title');
          const closeBtn = document.createElement('button');
          closeBtn.className = 'mm-close';
          closeBtn.setAttribute('aria-label', 'Close menu');
          closeBtn.innerHTML = 'Close';

          mmTitle.appendChild(closeBtn);
          // Add event listener to close menu

          closeBtn.addEventListener('click', () => {
            document.querySelector('#off-canvas').mmApi.close();
          });
        }, 500);

        /**
         * Prepend image alt text or link text to title if opening in a new
         * window.
         */



        // Move modals to the bottom of the bottom to escape the wrapper and its
        // z-index issues
        // $('.modal').each((index, element) => {
        //   $(element).appendTo('body');
        // });

        // When a bootstrap modal is closed, stop vimeo videos
        $(document).on('hide.bs.modal', (evt) => {
          const iframe = $('.video-embed-field-provider-vimeo iframe', $(evt.target));
          if (iframe.length > 0) {
            /* global Player */
            const player = new Player(iframe);
            player.pause();
          }
          // Youtube videos
          const youtubeIframe = $('.video-embed-field-provider-youtube iframe', $(evt.target));
          if (youtubeIframe.length > 0) {
            youtubeIframe[0].contentWindow.postMessage('{"event":"command","func":"stopVideo","args":""}', '*');
          }
        });

        // When a bootstrap modal is opened, start vimeo videos
        $('.paragraph--type-video-column [data-toggle="modal"]').on('click', (evt) => {
          // Vimeo videos
          // $(evt.target).attr('data-target')
          const target = $(evt.target).closest('button').data('target');
          const $modal = $(target);
          const iframe = $('.video-embed-field-provider-vimeo iframe', $modal);
          if (iframe.length > 0) {
            const player = new Player(iframe);
            player.play();
          }
          // Youtube videos
          const youtubeIframe = $('.video-embed-field-provider-youtube iframe', $modal);
          if (youtubeIframe.length > 0) {
            youtubeIframe[0].contentWindow.postMessage('{"event":"command","func":"playVideo","args":""}', '*');
          }
        });

        if (document.querySelector('.paragraph--type-cidrap-news')) {
          map(document.querySelectorAll('.paragraph--type-cidrap-news'), (feed) => {
            // Retrieve news api from proxied REST endpoint
            axios.get('/api/vip/news')
              .then((response) => {
                const h2 = document.createElement('h2');
                const link = document.createElement('a');
                const wrapper = document.createElement('div');
                const linkWrapper = document.createElement('div');
                linkWrapper.classList.add('link-wrapper');
                h2.innerHTML = 'News from CIDRAP';
                link.innerHTML = 'All Vaccine Integrity Project News';
                link.setAttribute('href', 'https://www.cidrap.umn.edu/vaccine-integrity-project');
                linkWrapper.appendChild(link);
                map(response.data[0].slice(0, 4), (item) => {
                  const div = document.createElement('div');
                  div.classList.add('cvr-news-teaser');
                  // If there's a thumbnail, show title and thumbnail
                  /* eslint-disable camelcase */
                  const {
                    field_date_time,
                    field_authors,
                    field_image_thumbnail,
                    title,
                    url,
                  } = item;
                  if (field_image_thumbnail) {
                    div.innerHTML = `
                      <div class="teaser-with-thumbnail">
                        <a href="${url}">
                          <div class="thumbnail-image">
                            ${field_image_thumbnail}
                          </div>
                          <div class="content">
                            <h3>${title}</h3>
                            <div class="date">
                              ${field_date_time}
                            </div>
                            <div class="authors">
                              ${field_authors}
                            </div>
                          </div>
                        </a>
                      </div>
                    `;
                    wrapper.appendChild(div);
                  // If there's not a thumbnail, but there is teaser text
                  } else {
                    div.innerHTML = `
                      <div class="teaser-without-thumbnail">
                        <a href="${url}">
                          <h3>${title}</h3>
                          <div class="date">
                            ${field_date_time}
                          </div>
                          <div class="authors">
                            ${field_authors}
                          </div>
                        </a>
                      </div>
                    `;
                    wrapper.appendChild(div);
                  // If there's not a thumbnail or teaser text
                  }
                });
                /* eslint-disable */
                feed.innerHTML = '';
                feed.appendChild(h2);
                feed.appendChild(wrapper);
                feed.appendChild(linkWrapper);
              })
              .catch((error) => {
                console.log(error);
              });
          });
        }

        if (document.querySelector('.view-database-table th a')) {
          const tableHeaders = document.querySelectorAll('.view-database-table th a');
          map(tableHeaders, (link) => {
            const src = link.getAttribute('href');
            if (!src.match('active_tab')) link.setAttribute('href', `${src}&active_tab=table`);
          });
        }
        // Move modals to end of body to prevent z-index issue
        const bsModals = document.querySelectorAll('.modal');
        map(bsModals, modal => document.body.appendChild(modal));

        // Scroll to vaccine database, if present and filters are active
        if (document.querySelector('.paragraph--type-vaccine-database')) {
          const q = queryString.parse(window.location.search);
          console.log(q);
          if (q && (q.keyword || q.platform || q.phase || q.developer || q.status || q.mechanism)) {
            const $target = $(document.querySelector('.paragraph--type-vaccine-database'));
            $('html, body').animate({
              scrollTop: $target.offset().top,
            }, 0);
          }
        }

        // Anchor links smooth scrolling to position.
        if (document.querySelector('.view-anchor-links, .view-section-header-nav, .paragraph--type-cta-links')) {
          $('.view-anchor-links a[href*="#"], .view-section-header-nav a[href*="#"], .paragraph--type-cta-links a[href*="#"]')
            // Remove links that don't actually link to anything
            .not('[href="#"]')
            .not('[href="#0"]')
            .click(function (event) {
              // On-page links
              if (
                location.pathname.replace(/^\//, '') == this.pathname.replace(/^\//, '')
                &&
                location.hostname == this.hostname
              ) {
                // Figure out element to scroll to
                var target = $(this.hash);
                target = target.length ? target : $('[name=' + this.hash.slice(1) + ']');
                // Does a scroll target exist?
                if (target.length) {
                  // Only prevent default if animation is actually gonna happen
                  event.preventDefault();
                  // If the section nav is not collapsed at first, we need to adjust the offset
                  if ($(this).parents().hasClass('unfixed')) {
                    var menuheight = $('.unfixed').height();
                    var scrolloffset = target.offset().top - menuheight - 50;
                  }
                  else {
                    var scrolloffset = target.offset().top - 50;
                  }
                  $('html, body').animate({
                    scrollTop: scrolloffset
                  }, 1000, function () {
                    // Callback after animation
                    // Must change focus!
                    var $target = $(target);
                    $target.focus();
                    if ($target.is(":focus")) { // Checking if the target was focused
                      return false;
                    } else {
                      $target.attr('tabindex', '-1'); // Adding tabindex for elements not focusable
                      $target.focus(); // Set focus again
                    };
                  });
                }
              }
            });
        }

        // Adding links to tracker to drop to the database
        if (document.querySelector('.paragraph--type-vaccine-tracker')) {
          var $overview = $('.vaccine-tracker--overview');
          $overview.append('<span class="see-all"><span>See All</span></span>');
          $overview
            .click(function (event) {
              var $target = $(document.querySelector('.paragraph--type-vaccine-database'));
              $('html, body').animate({
                scrollTop: $target.offset().top - 100
              }, 1000);
            });
        }

        // Preclinical titles length alterations
        $('.node--type-candidate.node--view-mode-preclinical-teaser > button').each(function () {
          var $this = $(this);

          // Node name/title
          var $title = $(this).find('> .field--name-node-title h2');
          var $titleLength = $title.text().length;
          var $titleString = $title.text().substr(0, 30);
          var $lastIndexOf = $titleString.lastIndexOf(' ');
          if ($titleLength > 30) {
            $title.text($titleString.substr(0, $lastIndexOf) + '\n' + '…');
          }
          // Developer length
          var $developer = $(this).find('> .field--name-field-developer .field__item');
          var $devLength = $developer.text().length;
          var $devString = $developer.text().substr(0, 30);
          var $devLastIndexOf = $devString.lastIndexOf(' ');
          if ($devLength > 30) {
            $developer.text($devString.substr(0, $devLastIndexOf) + '\n' + '…');
          }
        });

        // Clinical Trial Teaser developer length alterations
        $('.node--type-candidate.node--view-mode-clinical-trial-teaser > button > .field--name-field-developer .field__item').each(function () {
          var len = $(this).text().length;
          var str = $(this).text().substr(0, 50);
          var lastIndexOf = str.lastIndexOf(' ');
          if (len > 50) {
            $(this).text(str.substr(0, lastIndexOf) + '\n' + '…');
          }
        });

        // Phase / platform table inherit colors.
        $('.platform-header .taxonomy-term--type-goal').each(function (event) {
          var $this = $(this);
          var $color = $this.data('theme-color');
          $(this).parent().parent().next('tr').addClass('color-theme-' + $color);
        });

        // Reset search button change.
        $('.paragraph--type-vaccine-database').each(function (event) {
          var $this = $(this);
          var $anchor = $this.find('.anchor-link').attr('name');
          var $form = $this.find('#views-exposed-form-database-phase-platform-phase');
          $form.find('#edit-reset')
            .click(function (event) {
              event.preventDefault();
              var previousPage = window.location.protocol + '//' + window.location.host + window.location.pathname;
              window.location.href = previousPage + '#' + $anchor;
            });
        });

        // Database snapshot table - mobile scroll arrows.
        $('.block.block-vaccine-database').each(function (event) {
          var $this = $(this);
          var $snapshot = $this.find('#snapshot');
          var $table = $snapshot.find('.table.snapshot');
          var $slide = 0;
          $table.attr('left', $slide);
          var $nav = $this.find('#snapshot-nav');
          $(window).on('load resize', function () {
            $table.css('margin-left', 0);
            $table.attr('left', 0);
          });
          $nav.find('> span').click(function (event) {
            if (event.target.classList.contains('fa-chevron-left')) {
              if ($table.attr('left') <= 3) {
                $slide++;
                $table.css('margin-left', '-=250px');
                $table.attr('left', $slide);
              }
            }
            if (event.target.classList.contains('fa-chevron-right')) {
              if ($table.attr('left') >= 1) {
                $slide--;
                $table.css('margin-left', '+=250px');
                $table.attr('left', $slide);
              }
            }
          });
        });

        // Overlay node apply color class to modal itself as well.
        $('.node--type-candidate.node--view-mode-overlay').each(function () {
          var $this = $(this);
          var classList = $this[0].className.split(/\s+/);
          $.each(classList, function (index, value) {
            if (value.startsWith('color-theme-')) {
              $this.parent().parent().parent().addClass(value);
              $this.attr('data-theme-color', value);
            }
          });
        });

        // Logo callout component.
        // Add class to parent wrapper to target subsequent of the same for styling reasons.
        $('.paragraph--type-logo-callout').each(function (event) {
          var $this = $(this);
          $(this).parent().addClass('paragraph-logo-callout');
        });

        // Section header component.
        $('.paragraph--type-section-header').each(function (event) {
          var $this = $(this);
          $(this).parent().addClass('section-header');
          setTimeout(() => {
            var $count = $this.parent().attr('data-count');
            $this.find('.field--name-field-title').attr('data-parent-count', $count + '.');
          }, 1);

        });

        if (document.querySelector('.paragraph--type-section-header')) {
          var sections = document.getElementsByClassName('field__item section-header');
          for (var i = 0; i < sections.length; i++) {
            sections[i].setAttribute('data-count', i + 1);
          }
        }

        // Section Nav fixed
        function fixSectionNav() {
          var $sectionNav = $('.paragraph--type-section-nav');
          $sectionNav.addClass('unfixed');
          var $sectionInner = $('.paragraph--type-section-nav > div > .inner');
          if ($(window).scrollTop() > $sectionNav.data('top')) {
            $sectionNav.css({ 'position': 'fixed', 'top': '0', 'width': '100%', 'z-index': '1000' });
            $sectionNav.addClass('fixed').addClass('collapsed').removeClass('unfixed');
            $sectionInner.slideUp();
          }
          else {
            $sectionNav.css({ 'position': 'relative', 'top': 'auto', 'width': '100%' });
            $sectionNav.removeClass('fixed').removeClass('collapsed').addClass('unfixed');
            $sectionInner.slideDown();
          }
        }

        if (document.querySelector('.paragraph--type-section-nav')) {
          var $sectionNav = $('.paragraph--type-section-nav');
          $sectionNav.addClass('unfixed');
          $('.paragraph--type-section-nav').data('top', $('.paragraph--type-section-nav').offset().top); // set original position on load
          $(window).scroll(fixSectionNav);
        }

        $('.paragraph--type-section-nav').each(function (event) {
          var $sectionNav = $(this);
          var $toggle = $sectionNav.find('h2');
          var $content = $sectionNav.find('.inner');
          $toggle.on('click touch', (evt) => {
            if ($sectionNav.hasClass('collapsed')) {
              $sectionNav.removeClass('collapsed');
              $content.slideDown();
            } else {
              $sectionNav.addClass('collapsed');
              $content.slideUp();
            }
          });
          // Section nav file download set to target="_blank"
          $('.field--name-field-file-download a').attr('target', '_blank');
        });

        $('.form-item-platform select, .form-item-phase select, .form-item-developer select, .form-item-mechanism select, .form-item-status select, .form-item-models select, .form-item-antigen select, .form-item-country select').on('click touch', (evt) => {
          evt.stopPropagation();
        });

        /* global document, window */
        // Check for a hash value on page load and activate a matching tab.
        if (window.location.search) {
          const parsed = queryString.parse(window.location.search);
          const active = parsed.active_tab;
          if (active) {
            const $activeTab = $(`a[data-toggle="tab"][data-slug="${active}"]`);
            $activeTab.tab('show');
          }
        }
        // When a bootstrap tab is activated reflect, update the hash value
        setTimeout(() => {
          $('a[data-toggle="tab"]').on('shown.bs.tab', (evt) => {
            const slug = $(evt.target).data('slug');
            $(evt.target).closest('form').find('[name="active_tab"]').val(slug);
          });
        }, 500);

        // Search box - to go to main CIDRAP site
        $('#cidrap-search-submit').click(function (event) {
          event.preventDefault();
          location.href = 'https://www.cidrap.umn.edu/search/' + $('#cidrap-search-input').val();
        });

        // Overlay print.
        $('.overlay-print > a').click(function (event) {
          event.preventDefault();
          window.print();
        });

        $('[name="keyword"]').keypress((evt) => {
          const { which } = evt;
          if (which === 13) {
            evt.preventDefault();
            $(evt.target).closest('form').find('> .form-row [type="submit"]').click();
          }
        });

        $('.paragraph--type-accordion').each(function (index, element) {
          var $container = $(this);
          var $title = $('.accordion--title', $container);
          var $content = $('.accordion--content', $container);
          $content.slideUp();
          var containerClass = 'accordion-container-' + index;
          $title.on('click touch', function (e) {
            $container.toggleClass('expanded');
            $content.slideToggle();
          });
          $container.addClass(containerClass);
        });
      });
    },
  };
})(jQuery, Drupal);
